import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { take } from 'rxjs/operators';
import { CompanyService } from 'src/app/services/company.service';
import { LoginService } from 'src/app/services/login.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { URI } from 'src/app/settings/uri-constants';

@Component({
    selector: 'app-enterprise-navigation',
    templateUrl: './enterprise-navigation.component.html',
    styleUrls: ['./enterprise-navigation.component.css'],
})
export class EnterpriseNavigationComponent implements OnInit {
    logoutModalDisplay = 'none';
    iconName: string = 'logout-icon';
    name: string;
    uri = URI;
    sessionUser$ = this.loginService.sessionUser.asObservable();
    navigationItems = this.navService.getEnterpriseNavItems();
    expandedMenus: { [key: string]: boolean } = {};
    hasActiveChild: { [key: string]: boolean } = {};
    manuallyToggled: { [key: string]: boolean } = {};

    constructor(
        public loginService: LoginService,
        public companyService: CompanyService,
        private router: Router,
        private navService: NavigationService,
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.updateExpandedMenusByUrl(event.urlAfterRedirects);
                this.updateActiveParents();
            });
    }

    ngOnInit() {
        this.sessionUser$
            .pipe(take(1)) // take only once to avoid memory leaks or duplicate requests
            .subscribe((user) => {
                if (user) {
                    this.name = user.name;
                }
            });
    }

    updateExpandedMenusByUrl(url: string) {
        this.navService.updateExpandedMenusByUrl(
            url,
            this.navigationItems,
            this.manuallyToggled,
            this.expandedMenus
        );
    }

    updateActiveParents() {
        this.navService.updateActiveParents(
            this.navigationItems,
            this.hasActiveChild
        );
    }

    toggleMenu(menuName: string, event: MouseEvent) {
        this.navService.toggleMenu(
            menuName,
            this.expandedMenus,
            this.manuallyToggled,
            event
        );
    }

    mouseEnter() {
        this.iconName = this.iconName === 'logout-icon' ? 'logout-hover' : 'logout-icon';
    }

    logout() {
        this.logoutModalDisplay = 'block';
    }

    closeModal() {
        this.logoutModalDisplay = 'none';
    }

    submit() {
        this.loginService.logout();
    }
}
